import fetch, { ResponseError } from '@adeira/fetch';
import ACCOUNT_CONSTS from '@kiwicom/account-consts';
import btoa from 'btoa-lite';
import { format } from '@kiwicom/useragent';

export type VerifyEmailResponse = {
  readonly error_code: string;
  readonly message: string;
} & {
  readonly email_verified: string;
  readonly token: string;
};

const verifyEmail = async (
  token: string,
  clientIp: string,
): Promise<{
  authToken: string;
}> => {
  try {
    const response = await fetch(`${ACCOUNT_CONSTS.URLS.SKY_USERS_API}/v1/user.verifyEmail`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Client': 'Account-FE',
        Authorization: `Basic ${btoa(`${ACCOUNT_CONSTS.APP_ID}:`)}`,
        'X-Real-Ip': clientIp ?? '',
        'User-Agent': format(
          'account-frontend',
          process.env.NEXT_PUBLIC_COMMIT_SHORT_SHA,
          process.env.APP_ENV,
        ),
      },
      retryDelays: [],
      body: JSON.stringify({
        email_token: token,
      }),
    });
    const json: VerifyEmailResponse = await response.json();

    if (json.error_code != null) {
      throw new Error(json.error_code);
    }

    return {
      authToken: json.token,
    };
  } catch (error) {
    // when final response returns HTTP status <200 or >=300
    if (error instanceof ResponseError) {
      const json = await error.response.json();
      throw new Error(json.error_code);
    } else {
      throw new Error(error.message);
    }
  }
};

export default verifyEmail;
